import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

// assets
import {
  ClockIcon,
  FireIcon,
  LocationIcon,
  ChevronDown,
} from "src/assets/icons";
import { GrSend } from "react-icons/gr";

// utils
import { convertToSlug } from "src/utils/helpers";
import { trimText } from "src/content/MapContent/utils";

import styles from "./Item.module.scss";
const cx = classNames.bind(styles);

const SliderItem = ({ data, isGrow, toggle }) => {
  const [showSeeMore, setShowSeeMore] = useState(false);

  useEffect(() => {
    if (data && data.Description.length >= 120) {
      setShowSeeMore(true);
    }
  }, [data]);

  const openTicketUrl = () => {
    window.open(data.TicketUrl);
  };

  const getUrl = () => {
    let slug = convertToSlug(data.EventName);
    return `/${slug}/${data.EventId}/${data.TimeId}`;
  };

  return (
    <div className={cx("map-slider-item-root", { isGrow })}>
      <span className={cx("btn-shrink", { rotate: isGrow })} onClick={toggle}>
        <ChevronDown />
      </span>
      <div className={cx("item-header")}>
        <img src={data.Image} alt="..." />
        <div className={cx("group")}>
          <Link to={getUrl}>
            <h4 className={cx("title")}>{data.EventName}</h4>
          </Link>
          <div className={cx("info")}>
            <div className={cx("start-time")}>
              <ClockIcon />
              <span>{data.StartTime}</span>
            </div>
            {data.IsTrending === "1" && (
              <div className={cx("is-trending")}>
                <FireIcon />
                <span>Trending</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <p className={cx("item-description")}>
        <span className={cx("text")}>{trimText(data.Description, 120)}</span>
        {showSeeMore && (
          <Link to={getUrl}>
            <span className={cx("see-more")}>see more</span>
          </Link>
        )}
      </p>
      <div className={cx("item-footer")}>
        <div className={cx("group", "location-icon")}>
          <LocationIcon />
          <span>{data.Location}</span>
        </div>
        <div className={cx("group", "mile-icon")}>
          <GrSend color="#00aff0" />
          <span>{data.DistanceMile} mile(s) away</span>
        </div>
      </div>
      {data.TicketUrl !== "" && (
        <button className={cx("btn-ticket")} onClick={openTicketUrl}>
          Get Ticket
        </button>
      )}
    </div>
  );
};

export default SliderItem;
